import {adminServerInstance} from '../axios/instances';
import {
    LOAD_RESEND_ORDERS,
    LOAD_RESEND_ORDERS_SUCCESS,
    LOAD_RESEND_ORDERS_FAIL,
    LABEL_PRINT,
    LABEL_PRINT_SUCCESS,
    LABEL_PRINT_FAIL
} from './types';

export function labelPrint(params) {
    return function(dispatch) {
        dispatch({type: LABEL_PRINT})
        return adminServerInstance.post(`/business/printresendorderlabel`,{
            tno: [params]
        })
        .then(({data}) => {
            dispatch({
                type: LABEL_PRINT_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: LABEL_PRINT_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function loadResendOrders(rs, cr) {
    return function(dispatch) {
        dispatch({type: LOAD_RESEND_ORDERS})
        return adminServerInstance.post(`/business/getresendorders`, {
            request_no: rs,
            batch_no: cr,
            version: 1
        })
        .then(({data}) => {
            dispatch({
                type: LOAD_RESEND_ORDERS_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: LOAD_RESEND_ORDERS_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export const loadRsOptions = () => (dispatch) => {
    return adminServerInstance
        .get(`/business/getresendbatchnos`)
        .then(({data}) => {
            return Promise.resolve(data.data);
        }).catch(error => {
            return Promise.reject(error);
        })
};

export const loadCrOptions = (rs) => (dispatch) => {
    return adminServerInstance
        .get(`/business/getresendrequestnos?mawb=${rs}`)
        .then(({data}) => {
            return Promise.resolve(data.data);
        }).catch(error => {
            return Promise.reject(error);
        })
};

export const uploadResendOrder = (data, onUploadProgress) => (dispatch) => {
    let formData = new FormData()
    formData.append('resent_list', data.file, data.file.name);
    formData.append('local_import', 1);
    formData.append('req_date', data.req_date);
    // formData.append('warehouse', data.warehouse);
    formData.append('version', 1);

    return adminServerInstance
        .post('/business/createresendorder', 
        formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            ...onUploadProgress,
        }).then(({data}) => {
            return Promise.resolve(data.data);
        }).catch(error => {
            return Promise.reject(error);
        })
}